import lodash from "lodash";
import Base from "../base.store";

const baseUrl = "/api/v1/transaction/requests";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        request(context, { data, config }) {
            return base.request.put(`${baseUrl}/request`, data, { ...config });
        },
        requestAll(context, { data, config }) {
            return base.request.put(`${baseUrl}/request_all`, data, { ...config });
        },
        reStatus(context, { data, config }) {
            return base.request.put(`${baseUrl}/re-status`, data, { ...config });
        },
        unlock(context, { data, config }) {
            return base.request.put(`${baseUrl}/unlock`, data, { ...config });
        },
        reportHaz(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/haz`, data, { ...config, responseType: "blob" });
        },
        reportStorageLocation(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/storage-location`, data, { ...config, responseType: "blob" });
        },
        reportInform(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/inform`, data, { ...config, responseType: "blob" });
        },
        reportHazDiscuss(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/haz-discuss`, data, { ...config, responseType: "blob" });
        },
        reportManufactureSample(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/manufacture-sample`, data, { ...config, responseType: "blob" });
        },
        reportHazLicense(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/haz-license`, data, { ...config, responseType: "blob" });
        },
        reportInspection(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/inspection`, data, { ...config, responseType: "blob" });
        },
        reportHc(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/hc`, data, { ...config, responseType: "blob" });
        },
        reportToWhom(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/to-whom`, data, { ...config, responseType: "blob" });
        },
        confirmHc(context, { data, config }) {
            return base.request.post(`${baseUrl}/confirm/hc`, data, { ...config });
        },
        calculateHazDiscuss(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/calculate-haz-discuss`, data, { ...config });
        },
        reportFreeSale(context, { data, config }) {
            return base.request.post(`${baseUrl}/report/free-sale`, data, { ...config, responseType: "blob" });
        },
        getShortDetails(context, { criteria, config }) {
            return base.request.post(`${baseUrl}/short-details`, criteria, { ...config });
        },
        getShortDetail(context, { id, config }) {
            return base.request.get(`${baseUrl}/short-detail/${id}`, { ...config });
        },
        sendNsw(context, { data, config }) {
            return base.request.post(`${baseUrl}/send/nsw`, data, { ...config });
        },
        sendNswOGAInspectionResult(context, { data, config }) {
            return base.request.post(`${baseUrl}/send/nsw-oga-inspection-result`, data, { ...config });
        },
        sendNswRelease(context, { data, config }) {
            return base.request.post(`${baseUrl}/send/nsw-release`, data, { ...config });
        }
    },
    mutations: {
        ...base.mutations
    }
};
